export default {"src":"/_next/static/media/mark-white.0236741f.svg","height":276,"width":277,"blurWidth":0,"blurHeight":0};